// extracted by mini-css-extract-plugin
export default {"DivBackgroundWrapper":"_theme_DivBackgroundWrapper__2p3dp","DivBackgroundWrapperDark":"_theme_DivBackgroundWrapperDark__cYGPb"};